import { useState, useEffect } from 'preact/hooks'
import { getManyProductsBySKU } from 'hooks/useStorefront'
import { getSkuQueryEdges } from 'helpers/storefront-graphql-helper'
import { processSwatchData } from 'helpers/swatches'
import { globalEmitter } from 'helpers/emitter-event'

export default function PlpSwatches({ currentHandle, currentSku, setCurrentProduct, className = 'pb-2', buttonSizeClass = 'h-7 max-h-8 w-7 max-w-8', buttonActiveSizeClass = 'h-6 w-6', linkedColors, currentSize, isLastItem }) {
  const [productSwatches, setProductSwatches] = useState([])

  if (!linkedColors) {
    return <div className="plp-swatches-empty max-h-[30px] w-full flex-1"></div>
  }

  useEffect(() => {
    // required to be able to set current state
    if (currentSku && !linkedColors.includes(currentSku)) {
      linkedColors.unshift(currentSku)
    }

    const getSwatches = async () => {
      if (!linkedColors?.length) {
        return
      }
      const relatedProducts = await getManyProductsBySKU(linkedColors)
        .then((res) => {
          if (!res.ok || !res.json) {
            throw res
          }
          return res.json()
        })
        .then((body) => {
          if (body.errors) {
            throw body
          }
          // products query can still return fuzzy matches; only keep linked SKUs (same as PDP)
          const linkedProducts = processSwatchData(getSkuQueryEdges(body))
            .filter((product) => product?.sku?.some((sku) => linkedColors.includes(sku)))
          const swatches = linkedProducts
            // specifically using == to increase type tolerance - has already been an issue once
            // eslint-disable-next-line eqeqeq
            .filter((swatch) => swatch.size == currentSize && (swatch.color?.hex || swatch.color?.image?.src))
          return swatches
        })
        .catch((err) => {
          console.error('Some error during getSwatches', err)
          return []
        })
      setProductSwatches(relatedProducts)
      if (isLastItem) {
        globalEmitter.emit('fetch-success-swatch')
      }
    }
    getSwatches()
  }, [])

  const changeSwatch = (swatch) => {
    if (swatch.handle === currentHandle) return
    setCurrentProduct(
      swatch.handle,
      swatch.title,
      swatch.size,
      swatch.featuredImage.url,
      swatch.priceRange.minVariantPrice.amount * 100,
      swatch.compareAtPriceRange.minVariantPrice.amount * 100,
      swatch.images,
      swatch.video,
      swatch.tags,
      swatch.sku,
      swatch.prettyColorName,
      swatch.variants,
      swatch.bundleChilds,
      swatch.id,
      swatch.variants[0].id.split('/').pop()
    )

    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('swym:collections-loaded'))
    }, 1000)
  }

  return (
    <div className={`plp-swatches flex flex-wrap items-center gap-2 js-plp-swatches ${productSwatches && productSwatches.length > 0 ? className : ''}`}>
      {/* filter for nested props handled in setter */}
      {productSwatches && productSwatches.length > 0 && productSwatches.map((swatch) => {
        const isActiveStyling = swatch.handle === currentHandle ? `${buttonActiveSizeClass} border-focus` : ' border-transparent'
        const key = `${currentHandle}__${swatch.handle}`
        const swatchImage = swatch.color.image?.src
        return (
          <button
            key={key}
            className={`swatch rounded-full border p-0.5 ${buttonSizeClass} ${isActiveStyling}`}
            onClick={() => changeSwatch(swatch)}
            title={swatch.prettyColorName}
            data-sku={swatch.sku}
          >
            <span
              className="border border-focus block h-full w-full rounded-full !bg-contain"
              style={` ${swatchImage ? `background: url(${swatchImage})` : `background-color: ${swatch.color.hex}`} `}
            ></span>
          </button>
        )
      })}
    </div>
  )
}
